import React from 'react';
import './payment-advice.scss';
import { usePaymentAdvice } from './hooks/use-payment-advice';
import { LoadingSpinner, SVGS, PNGS } from '@zonofi/zono-money-design-system';
import { startCase } from 'lodash';
import { OrderStatusEnum } from '@zonofi/zono-money-helpers';

export const PaymentAdvice = () => {
  const {
    advanceAmount,
    isLoading,
    onBackBtnClick,
    onCopy,
    copiedLabel,
    bankAccountDetails,
    upiDetails,
    orderId,
    refOrderNumber,
    status,
    customerName,
    sellerName,
    cart,
  } = usePaymentAdvice();

  if (isLoading) {
    return (
      <div className="payment-advice-loading">
        <LoadingSpinner />
      </div>
    );
  }
  return (
    <div className="payment-advice-screen">
      {!cart ? (
        <div className="payment-advice-screen-navbar font-primary-semibold">
          <img src={SVGS.BackArrow} alt="" onClick={onBackBtnClick} />
          Payment Advice
        </div>
      ) : (
        <div className="payment-advice-screen-body-order-details-top-v2-header">
          <div className="payment-advice-screen-body-order-details-top-v2-order-submitted">
            <img
              src={PNGS.SubmittedIcon}
              className="payment-advice-screen-body-order-details-top-v2-order-submitted-icon"
            />
            <div className="payment-advice-screen-body-order-details-top-v2-order-submitted-text font-primary">
              Order Submitted
            </div>
            <div className="font-primary">
              {`Your order has been sent to ${sellerName}`}
            </div>
          </div>

          <div className="payment-advice-screen-body-order-details-top-v2-order-info-top">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div className="info-icon-view">
                <img src={SVGS.DocGreenIcon} />
              </div>

              <div>
                <div className="payment-advice-screen-body-order-details-top-v2-title font-primary">
                  Order Number
                </div>
                <div className="payment-advice-screen-body-order-details-top-v2-desc-top font-primary-semibold">{`Order ID #${status === OrderStatusEnum.ADDING_ITEMS ? orderId : refOrderNumber}`}</div>
              </div>
            </div>

            <div className="payment-advice-screen-body-order-details-top-v2-desc-view">
              <div
                className="payment-advice-screen-body-order-details-top-v2-copy-icon-top"
                onClick={() => onCopy(orderId, 'orderId')}
              >
                <img
                  src={
                    copiedLabel === 'orderId'
                      ? SVGS.CheckGreenIcon
                      : SVGS.CopyLightGrayIcon
                  }
                />
                {copiedLabel === 'orderId' ? (
                  <span className="font-primary">Copied</span>
                ) : (
                  <span className="font-primary">Copy</span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className="payment-advice-screen-body"
        style={{ ...(cart ? { marginTop: 0 } : {}) }}
      >
        {cart ? (
          <div
            className="payment-advice-screen-body-advance-card"
            style={{
              backgroundColor: '#FFF7E6',
              borderColor: '#FFEBC2',
              padding: 16,
            }}
          >
            <img src={SVGS.AWaiting} alt="" />

            <span className="payment-advice-screen-body-advance-card-text font-primary-semibold">
              Awaiting Advance Payment
              <br />
              <span className="font-primary">
                Pay the advance amount to help the seller accept your order
                faster.
              </span>
            </span>
          </div>
        ) : (
          <div className="payment-advice-screen-body-top">
            <div className="payment-advice-screen-body-advance-card">
              <div className="payment-advice-screen-body-advance-card-info-view">
                <img src={SVGS.InfoLightBlue} alt="" />
              </div>

              <span className="payment-advice-screen-body-advance-card-text font-primary-semibold">
                Pay the advance amount to confirm this order.{' '}
                <span className="font-primary">
                  Share the payment receipt with the seller once completed.
                </span>
              </span>
            </div>
          </div>
        )}

        <div className="payment-advice-screen-body-order-details">
          <div className="payment-advice-screen-body-order-details-top-v1">
            <img src={SVGS.MerchantIcon} alt="" />
            <div className="payment-advice-screen-body-order-details-top-v1-amount-view">
              <div className="payment-advice-screen-body-order-details-top-v1-amount font-primary-bold">
                {advanceAmount}
              </div>
              <div className="payment-advice-screen-body-order-details-top-v1-label font-primary">
                Advance Amount to Pay
              </div>
            </div>
          </div>
          <div className="payment-advice-screen-body-order-details-divider" />
          <div className="payment-advice-screen-body-order-details-top-v2">
            <div className="payment-advice-screen-body-order-details-top-v2-bank-view">
              <div className="payment-advice-screen-body-order-details-top-v2-bank-icon">
                <img src={SVGS.MerchantIcon} alt="" width={16} />
              </div>
              <div className="payment-advice-screen-body-order-details-top-v2-label font-primary-semibold">
                {customerName}
              </div>
            </div>

            <div className="payment-advice-screen-body-order-details-top-v2-order-info">
              <div className="payment-advice-screen-body-order-details-top-v2-title font-primary">
                Order reference
              </div>
              <div className="payment-advice-screen-body-order-details-top-v2-desc-view">
                <div className="payment-advice-screen-body-order-details-top-v2-desc font-primary-semibold">{`Order ID #${status === OrderStatusEnum.ADDING_ITEMS ? orderId : refOrderNumber}`}</div>
                <div
                  className="payment-advice-screen-body-order-details-top-v2-copy-icon"
                  onClick={() => onCopy(orderId, 'orderId')}
                >
                  <img
                    src={
                      copiedLabel === 'orderId'
                        ? SVGS.CheckGreenIcon
                        : SVGS.CopyLightGrayIcon
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {!cart && (
          <div className="payment-advice-screen-body-banner">
            <div className="payment-advice-screen-body-banner-left">
              <div className="payment-advice-screen-body-banner-icon-view">
                <img src={SVGS.DocGreenIcon} />
              </div>
              <div className="payment-advice-screen-body-banner-text font-primary-semibold">
                Include this order ID in the payment description.
              </div>
            </div>
            <img src={SVGS.CheckHollowIcon} />
          </div>
        )}

        {((upiDetails?.qrUrl && upiDetails?.id) ||
          bankAccountDetails.length > 0) && (
          <div className="payment-advice-screen-body-payment-title font-primary-semibold">
            Choose a payment method
          </div>
        )}

        {upiDetails?.qrUrl && upiDetails?.id && (
          <div className="payment-advice-screen-body-upi-details">
            <div className="payment-advice-screen-body-upi-details-top">
              <div className="payment-advice-screen-body-upi-details-top-left">
                <div className="payment-advice-screen-body-upi-details-top-upi">
                  <img src={SVGS.UpiIcon} alt="" />
                </div>
                <div className="payment-advice-screen-body-upi-details-top-label font-primary-semibold">
                  UPI
                </div>
              </div>
              <div className="payment-advice-screen-body-upi-details-top-right font-primary">
                Recommended
              </div>
            </div>

            <div className="payment-advice-screen-body-upi-details-divider" />
            <div className="payment-advice-screen-body-upi-details-content">
              <div className="payment-advice-screen-body-upi-details-content-title font-primary-semibold">
                Scan QR Code to Pay
              </div>
              <img
                src={upiDetails?.qrUrl}
                alt=""
                width={216}
                height={213}
                style={{ objectFit: 'contain' }}
              />
            </div>
            <div className="payment-advice-screen-body-upi-details-divider" />
            <div className="payment-advice-screen-body-upi-details-bottom">
              <div className="payment-advice-screen-body-upi-details-bottom-left">
                <div className="payment-advice-screen-body-upi-details-bottom-left-name font-primary-semibold">
                  {upiDetails?.name}
                </div>
                <div className="payment-advice-screen-body-upi-details-bottom-left-upi font-primary">
                  {upiDetails?.id}
                </div>
              </div>

              <div
                className="payment-advice-screen-body-upi-details-bottom-right font-primary-semibold"
                onClick={() => onCopy(upiDetails?.id, 'upiId')}
              >
                <img
                  src={
                    copiedLabel === 'upiId'
                      ? SVGS.CheckGreenIcon
                      : SVGS.CopyIconGray
                  }
                  alt=""
                />{' '}
                Copy
              </div>
            </div>
          </div>
        )}
        {bankAccountDetails.length > 0 && (
          <div className="payment-advice-screen-body-bank-details">
            <div className="payment-advice-screen-body-bank-details-top">
              <div className="payment-advice-screen-body-bank-details-top-icon-view">
                <img src={SVGS.BankIcon} alt="" />
              </div>
              <div className="payment-advice-screen-body-bank-details-top-info">
                <div className="payment-advice-screen-body-bank-details-top-title font-primary-semibold">
                  Bank Account
                </div>
                <div className="payment-advice-screen-body-bank-details-top-desc font-primary">
                  Transfer directly to our bank account
                </div>
              </div>
            </div>

            <div className="payment-advice-screen-body-bank-details-divider" />

            <div className="payment-advice-screen-body-bank-details-content">
              {bankAccountDetails.map((data, index) => {
                return (
                  <>
                    <div className="payment-advice-screen-body-bank-details-content-items">
                      <div className="payment-advice-screen-body-bank-details-content-label font-primary-semibold">
                        {startCase(data.label)}
                      </div>
                      <div
                        className="payment-advice-screen-body-bank-details-content-value font-primary-semibold"
                        onClick={() => {
                          onCopy(data.value, data.label);
                        }}
                      >
                        {data.value}
                        <div className="payment-advice-screen-body-bank-details-content-icon-view">
                          <img
                            src={
                              copiedLabel === data.label
                                ? SVGS.CheckGreenIcon
                                : SVGS.CopyIconGray
                            }
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    {index !== bankAccountDetails.length - 1 && (
                      <div className="horizontal-line"></div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
